import React from 'react'

const Products = props => {
    const classes = props.products.isInCart === true ? "btn btn-danger cart" : "btn btn-secondary cart"
    return (
        <React.Fragment>
            <div className="cont" >
                <div key={props.products.id} className="image">
                    <img data-aos={props.products.fade} data-aos-duration="1000" src={props.products.imgUrl} alt={props.products.name} />
                </div>
                <div className="text">
                    <h1>{props.products.name}</h1>
                    <div className="conn">
                        <h6>${props.products.price}</h6>
                        <button onClick={() => props.onClone(props.products)} className={classes}><img src="https://cdn-icons-png.flaticon.com/512/3737/3737151.png" alt="cart photo" /></button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Products